import { Box, Container, Divider, Flex, PrimaryButton, Text } from "flicket-ui";
import { atom, useAtom } from "jotai";
import { Modal } from "~components";
import { ExtendedFile } from "~graphql/sdk";
import { getImage } from "~lib";

export type Details = {
  name: string;
  description?: string;
  addonImage?: ExtendedFile;
  restrictions?: string;
  ticketImage?: ExtendedFile;
};

export const ticketDetailsAtom = atom<Details | undefined>(undefined);

export const TicketDetailsModal = () => {
  const [details, setDetails] = useAtom(ticketDetailsAtom);
  return (
    <Modal
      isOpen={!!details}
      // @ts-expect-error atom type issue while using strict:false
      onClose={() => setDetails(undefined)}
      height="auto"
      bg="transparent"
      aria-label="Ticket details"
    >
      <Container
        px={2}
        innerProps={{
          w: "100%",
          maxW: "560px",
          mx: "auto" as any,
          p: { _: 2, md: 4 },
        }}
      >
        <Text
          fontSize={6}
          fontWeight="heavy"
          lineHeight="normal"
          color="N800"
          mb={4}
        >
          {details?.name}
        </Text>

        {details?.addonImage && (
          <Box
            backgroundSize="cover"
            backgroundPosition="center"
            style={{
              backgroundImage: `url(${getImage(details?.addonImage)})`,
            }}
            height="320px"
            mt={3}
          />
        )}

        {details?.description ? (
          <>
            <Text fontSize={4} fontWeight="extraBold" color="N700">
              Description
            </Text>
            <Text fontSize={2} color="N500" mb={details?.restrictions && 2}>
              {details?.description}
            </Text>
          </>
        ) : null}

        {details?.ticketImage && (
          <Box
            backgroundSize="cover"
            backgroundPosition="center"
            style={{
              backgroundImage: `url(${getImage(details?.ticketImage)})`,
            }}
            height="320px"
            mt={3}
          />
        )}
        {details?.restrictions ? (
          <>
            <Text fontSize={4} fontWeight="extraBold" color="N700">
              Restrictions
            </Text>
            <Text fontSize={2} color="N500">
              {details?.restrictions}
            </Text>
          </>
        ) : null}
        <Divider my={3} />
        <Flex w="100%" justifyContent="flex-end">
          {/* @ts-expect-error atom type issue while using strict:false */}
          <PrimaryButton onClick={() => setDetails(undefined)}>
            Close
          </PrimaryButton>
        </Flex>
      </Container>
    </Modal>
  );
};
